module.exports = __webpack_public_path__ + "media/img/corporate/career-mag-1613af7b4143e8c8c97f4d8e0db82637.png";